import { Directive, Input, ElementRef, AfterViewInit, inject } from '@angular/core';

@Directive({
    selector: '[appSpinnerColor]',
    standalone: false
})
export class SpinnerColorDirective implements AfterViewInit {
    @Input('appSpinnerColor') color: string;

    private elem = inject(ElementRef);

    ngAfterViewInit() {
        const element = this.elem.nativeElement;
        const circle = element.querySelector('circle');
        circle.style.stroke = this.color;
        circle.style['stroke-linecap'] = 'round';
    }
}
